import React, { useCallback, useContext, useState } from "react";
import { useEffect } from "react";
import { UserData } from "../../../Context/DataContext";
import { decryptText, encryptText, pbdkf2 } from "../../../Utils/OstreonEncryption";
import { generateKey } from "../../Register/Register";
import styles from "./styles/RecoveryCode.module.css"
import Confirmation from "../../Confirmation/Confirmation";
import { useNavigate } from "react-router-dom";
import { UpdateRecoverykey } from "../../../Utils/RenewPWD";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
function RecoveryCode({ OnClose }) {
    const userData = UserData()
    const navigate = useNavigate()
    var private_key = userData.private_key
    const [modal, setModal] = useState()
    const [code, setCode] = useState()
    const [error, setError] = useState()
    const [copy, setCopy] = useState()
    const [checked, setChecked]=useState(false)
    const websiteCurrentLang = useContext(LanguageContext).language;
    const [content, setContent] = useState(
        websiteCurrentLang.content.User.MyAccount.RecoveryCode
    );
    const [dublicatedcontent, setDublicatedContent] = useState(
        websiteCurrentLang.content.DublicatedText
    );
    useEffect(() => {
        setContent(websiteCurrentLang.content.User.MyAccount.RecoveryCode);
        setDublicatedContent(websiteCurrentLang.content.DublicatedText);
    }, [websiteCurrentLang]);
    const decryptCode = useCallback(async (private_key, encrypted_code) => {
        let decrypted_code = await decryptText(private_key, encrypted_code)
        setCode(decrypted_code)
        return decryptCode
    }, [])
    useEffect(() => {
        // const Weglot = document.createElement("script")
        // Weglot.src = "https://cdn.weglot.com/weglot.min.js"
        // document.body.appendChild(Weglot)
        // Weglot.onload = () =>{
        //   console.log('Script is loaded')
        //   window.Weglot.initialize({
        //     api_key: 'wg_fe59e91dbf7c41abd8908f1b88215ff17',
        //   });
        // }
        
        document.documentElement.style.overflow = "hidden";
        return () => {
            document.documentElement.style.overflow = "unset";
        };
        
    }, []);
    const CopyClipboard = (text) => {
        setCopy(true);
        navigator.clipboard.writeText(text)
    }
    const renewRecoveryCode = async () => {
        const recoverykey = generateKey()
        try {
            const [key_pbdkf,] = await pbdkf2(recoverykey, 'OSTREON', 100000, 32 * 8)
            await UpdateRecoverykey(key_pbdkf)
            const private_key_recovery_key = await encryptText(recoverykey, private_key)
            const recovery_key_private_key = await encryptText(private_key, recoverykey)
            userData.setCustomerUser({ ...userData.CustomerUser, "recovery_key_private_key": recovery_key_private_key, "private_key_recovery_key": private_key_recovery_key })
        } catch (e) {
            console.log(e)
            setError(content.recoveryCodeError1);
            setTimeout(() => {
                setError()
            }, 5000);
        }

        setModal()
    }
    const enableMethods = () => {
        userData.setCustomerUser({...userData.CustomerUser, "code_copied":true})
        setTimeout(() => {
            userData.getCustomerUser()
            OnClose();
        }, 300);
        
        
    }
    useEffect(() => {
        decryptCode(private_key, userData.CustomerUser.recovery_key_private_key)
    }, [userData.CustomerUser, decryptCode, private_key])

    return (
        <div className={styles.background}>
            <div onClick={(e) => { e.stopPropagation() }} className={styles.main_box} >
                <div onClick={OnClose} className={styles.close_logo} />
                <div className={styles.title}>{content.recoveryCodeText1}</div>
                <div className={styles.subtitle}>{content.recoveryCodeText2}</div>

                <div className={styles.error_top}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" fill="none"><path fill="#B30606" d="M23.04 17.39 14.112 1.713a2.456 2.456 0 0 0-.892-.908 2.409 2.409 0 0 0-2.44 0c-.371.218-.679.531-.893.908L.96 17.39a2.494 2.494 0 0 0-.011 2.477c.214.377.522.69.893.907a2.4 2.4 0 0 0 1.22.329h17.875a2.4 2.4 0 0 0 1.221-.33c.371-.216.68-.53.893-.906a2.495 2.495 0 0 0-.011-2.477ZM11.187 8.726c0-.218.086-.428.238-.583a.806.806 0 0 1 1.15 0 .832.832 0 0 1 .237.583v4.126a.831.831 0 0 1-.238.583.806.806 0 0 1-1.149 0 .831.831 0 0 1-.238-.583V8.726ZM12 17.802c-.241 0-.477-.072-.677-.208-.2-.136-.357-.33-.45-.556a1.255 1.255 0 0 1 .265-1.348 1.201 1.201 0 0 1 1.328-.268c.223.093.413.252.547.455a1.251 1.251 0 0 1-.151 1.563 1.21 1.21 0 0 1-.862.362Z"/><path fill="#fff" d="M11.187 8.726c0-.218.086-.428.238-.583a.806.806 0 0 1 1.15 0 .832.832 0 0 1 .237.583v4.126a.831.831 0 0 1-.238.583.806.806 0 0 1-1.149 0 .831.831 0 0 1-.238-.583V8.726ZM12 17.802c-.241 0-.477-.072-.677-.208-.2-.136-.357-.33-.45-.556a1.255 1.255 0 0 1 .265-1.348 1.201 1.201 0 0 1 1.328-.268c.223.093.413.252.547.455a1.251 1.251 0 0 1-.151 1.563 1.21 1.21 0 0 1-.862.362Z"/></svg>
                    <span>{content.recoveryCodeText3}</span>
                </div>

                <div className={styles.header}>
                    {content.recoveryCodeText6}
                    {/* <strong className={styles.strong}>{content.recoveryCodeText7}</strong> */}
                    {content.recoveryCodeText8}</div>
                <div className={styles.code}>{code}</div>

                {copy ? (
                    <div className={styles.greenbutton}>{dublicatedcontent?.copied}</div>
                ): (
                    <div onClick={() => CopyClipboard(code)} className={styles.bluebutton}>{content.recoveryCodeText4}</div>
                )}
               
                {!userData?.CustomerUser?.code_copied&&<>
                <div className={styles.rect} />
                {error && <div className={styles.error_message}>{error}</div>}

                <div className={styles.delete_actions}>
                    <div onClick={(e)=>{setChecked(!checked)}} 
                        className={`${styles.checkbox} ${(checked)?styles.checked:styles.not_checked}`}/>
                    <div className={styles.delete_text}>{content.recoveryCodeText5}</div>
                </div>

                <div className={styles.footer}>
                    <div onClick={() => enableMethods()} className={`${styles.bluebutton} ${checked ? '' : styles.btn_disabled}`}>{dublicatedcontent.dublicatedText75}</div>
                    <div onClick={OnClose} className={styles.whitebutton}>{dublicatedcontent.dublicatedText76}</div>
                </div></>
                
                }
            </div>
            {
                modal &&
                <div>
                    {modal}
                </div>
            }
        </div>
    )

}
export { RecoveryCode };